import React, {Fragment, useState} from 'react';

import {CTAButtonFixed} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {Loading} from 'presentation/components/Loading/Loading';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {FooterButtonProps} from './types';

const {keep} = translations['pt-br'].commons;
const {cancelAndBack, backToConference} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage;

export function FooterButton({
	isDisabled,
	isLoading,
	primaryTitle,
	primaryAction,
	secondaryTitle,
	secondaryAction,
	primaryButtonId,
	secondaryButtonId,
	isAdditionalRequestFlow,
	isFiscalDocumentStep,
	isEdit,
}: FooterButtonProps) {
	const [isSecondaryButtonClicked, setIsSecondaryButtonClicked] = useState(false);
	const {isMobile} = useMediaQueries();

	const CtaButtonFixedDirection = () => {
		if (isAdditionalRequestFlow && isMobile) {
			return 'column-reverse';
		}
		if (!isMobile) {
			return 'row';
		}

		return 'column';
	};

	const handleClickPrimary = () => {
		primaryAction();
		setIsSecondaryButtonClicked(false);
	};

	const handleClickSecondary = () => {
		secondaryAction();
		setIsSecondaryButtonClicked(true);
	};

	const showSecondaryEndIcon = isEdit && isLoading && isSecondaryButtonClicked;
	const showPrimaryEndIcon = isLoading && !isSecondaryButtonClicked;

	const titlePrimaryButton = primaryTitle || keep;
	const titleSecondaryButton = secondaryTitle || (isEdit ? backToConference : cancelAndBack);

	return (
		<CTAButtonFixed.Root
			direction={CtaButtonFixedDirection()}
			justifyContent="flex-end"
			px={isMobile ? 1 : 0}>
			{isAdditionalRequestFlow ? (
				<Fragment>
					<CTAButtonFixed.Action
						id={secondaryButtonId}
						type="submit"
						disabled={isEdit && isDisabled}
						size="large"
						variant="outlined"
						color="primary"
						onClick={handleClickSecondary}
						data-tag-id={
							isEdit
								? RefundTaggingEnum.CLICK_VOLTAR_PARAR_REVISAO_REEMBOLSO
								: undefined
						}
						endIcon={
							showSecondaryEndIcon ? <Loading size={16} color="inherit" /> : null
						}>
						{titleSecondaryButton}
					</CTAButtonFixed.Action>
					<CTAButtonFixed.Action
						id={primaryButtonId}
						data-tag-id={
							isFiscalDocumentStep
								? RefundTaggingEnum.CLICK_PROSSEGUIR_PARA_ANEXOS
								: RefundTaggingEnum.CLICK_CONTINUAR_STEP
						}
						size="large"
						disabled={isDisabled}
						variant="contained"
						color="primary"
						onClick={handleClickPrimary}
						endIcon={showPrimaryEndIcon ? <Loading size={16} color="inherit" /> : null}>
						{titlePrimaryButton}
					</CTAButtonFixed.Action>
				</Fragment>
			) : (
				<CTAButtonFixed.Action
					id={primaryButtonId}
					data-tag-id={
						isFiscalDocumentStep
							? RefundTaggingEnum.CLICK_PROSSEGUIR_PARA_ANEXOS
							: RefundTaggingEnum.CLICK_CONTINUAR_STEP
					}
					type="submit"
					size="large"
					disabled={isDisabled}
					variant="contained"
					color="primary"
					onClick={primaryAction}
					endIcon={isLoading ? <Loading size={16} color="inherit" /> : null}>
					{titlePrimaryButton}
				</CTAButtonFixed.Action>
			)}
		</CTAButtonFixed.Root>
	);
}
